import InputBase from "./InputBase";

export default InputBase;
